import { AfterViewInit, Component, OnInit } from '@angular/core';
import { TituloAbaService } from '../titulo-aba/titulo-aba.service';
import { environment } from '../../../environments/environment';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
@Component({
  selector: 'app-maquininha',
  templateUrl: './maquininha.component.html',
  styleUrls: ['./maquininha.component.scss']
})
export class MaquininhaComponent implements OnInit, AfterViewInit {

  public env = environment

  constructor(private tituloAbaService: TituloAbaService, private gtmService: GoogleTagManagerService) { }

  id = 332950684;
  public titulo: string = ''
  public gtm: string = ''
  private mainVideo: any

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.tituloAbaService.setTitle('Maquininhas');
    this.tituloAbaService.setMeta('description', 'Descubra a azulzinha ideal para o seu negócio! Reunimos aqui todas as opções de aluguel de maquininha da CAIXA para te ajudar a vender mais. ');
  }
  ngAfterViewInit() {
    this.mainVideo = document.querySelector('.video video')
    this.addEvent()
  }

  addEvent() {
    const self = this
    const onPlay = function () {

      self.onNavigation(self.gtm, 'play')
    }
    const onEnded = function () {

      self.onNavigation(self.gtm, 'fim')
    }

    this.mainVideo.removeEventListener('play', onEnded)
    this.mainVideo.removeEventListener('ended', onPlay)


    this.mainVideo.addEventListener('play', onPlay)
    this.mainVideo.addEventListener('ended', onEnded)
  }
  onNavigation(tag: string = '', event: any,) {
    this.gtm = tag
    let gtmtag = {
      event: `${event}-azulzinha-maquininha-caixa`,
      name: `${event} azulzinha maquininha da CAIXA`,
      id: this.id
    };
    this.gtmService.pushTag(gtmtag);

  }

}
